import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Card } from '@/components/ui/card';

const categories = [
  { id: 'tous', label: 'Tous' },
  { id: 'resultats', label: 'Résultats' },
  { id: 'voyages', label: 'Voyages' },
  { id: 'publi-reportage', label: 'Publi-Reportage' },
  { id: 'immersion', label: 'Immersion' },
  { id: 'promotion', label: 'Promotion' }
];

const photos = [
  { url: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=800", category: 'resultats', title: "Cérémonie de remise des diplômes" },
  { url: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?w=800", category: 'resultats', title: "Meilleurs étudiants 2024" },
  { url: "https://images.unsplash.com/photo-1427504494785-3a9ca7044f45?w=800", category: 'voyages', title: "Voyage d'étude - Paris" },
  { url: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800", category: 'voyages', title: "Échange universitaire" },
  { url: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=800", category: 'publi-reportage', title: "Campus moderne" },
  { url: "https://images.unsplash.com/photo-1498243691581-b145c3f54a5a?w=800", category: 'publi-reportage', title: "Bibliothèque universitaire" },
  { url: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800", category: 'immersion', title: "Travaux pratiques" },
  { url: "https://images.unsplash.com/photo-1531545514256-b1400bc00f31?w=800", category: 'immersion', title: "Salle de cours" },
  { url: "https://images.unsplash.com/photo-1511632765486-a01980e01a18?w=800", category: 'promotion', title: "Promotion 2024" },
  { url: "https://images.unsplash.com/photo-1509062522246-3755977927d7?w=800", category: 'promotion', title: "Étudiants en action" },
  { url: "https://images.unsplash.com/photo-1517486808906-6ca8b3f04846?w=800", category: 'immersion', title: "Laboratoire informatique" },
  { url: "https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=800", category: 'resultats', title: "Excellence académique" }
];

export default function Galerie() {
  const [activeCategory, setActiveCategory] = useState('tous');

  const filteredPhotos = activeCategory === 'tous' 
    ? photos 
    : photos.filter(photo => photo.category === activeCategory);

  return (
    <div className="min-h-screen bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 text-brand-secondary">Galerie Photo</h1>
          <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto">
            Découvrez les moments marquants de la vie à l'Université CEFAT International
          </p>
        </div>

        {/* Category Tabs */}
        <Tabs defaultValue="tous" className="w-full mb-12">
          <TabsList className="grid w-full grid-cols-3 md:grid-cols-6 bg-gray-100 p-2 rounded-lg gap-2">
            {categories.map(category => (
              <TabsTrigger 
                key={category.id}
                value={category.id}
                data-testid={`tab-${category.id}`}
                onClick={() => setActiveCategory(category.id)}
                className="data-[state=active]:bg-brand-primary data-[state=active]:text-white font-semibold py-2 px-4 rounded-md transition-all"
              >
                {category.label}
              </TabsTrigger>
            ))}
          </TabsList>

          {categories.map(category => (
            <TabsContent key={category.id} value={category.id} className="mt-8">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {filteredPhotos.map((photo, index) => (
                  <Card 
                    key={index} 
                    className="overflow-hidden card-hover bg-white border-gray-200 shadow-md cursor-pointer"
                    data-testid={`photo-card-${index}`}
                  >
                    <div className="relative group">
                      <img 
                        src={photo.url} 
                        alt={photo.title}
                        className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-110"
                      />
                      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all flex items-end">
                        <div className="p-4 text-white opacity-0 group-hover:opacity-100 transition-opacity transform translate-y-4 group-hover:translate-y-0">
                          <h3 className="font-bold text-lg">{photo.title}</h3>
                        </div>
                      </div>
                    </div>
                  </Card>
                ))}
              </div>
            </TabsContent>
          ))}
        </Tabs>

        {filteredPhotos.length === 0 && (
          <div className="text-center py-16">
            <p className="text-gray-500 text-lg">Aucune photo dans cette catégorie pour le moment.</p>
          </div>
        )}
      </div>
    </div>
  );
}